import { __assign, __generator } from "tslib";
import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { restrictLoggedOut, VERIFY_ACCESS, } from './actionCreators';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getPageBiContext } from '../../biLogger/redux/selectors';
function handleRestrictLoggedOut(_a) {
    var biContext, event_1, url;
    var _b = _a.payload, restrictedActionName = _b.restrictedActionName, returnTo = _b.returnTo, returnType = _b.returnType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!restrictedActionName) return [3 /*break*/, 3];
                return [4 /*yield*/, select(getPageBiContext)];
            case 1:
                biContext = _c.sent();
                event_1 = __assign(__assign({ evid: BiEventType.REDIRECT_TO_LOGIN }, biContext), { referral_info: restrictedActionName });
                return [4 /*yield*/, call(logBiEvent, event_1)];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3:
                url = Url.joinLink(undefined, returnTo, returnType);
                ddt.log('yumeruby', 'Loggedout redirect', url);
                window.location.assign(url);
                return [2 /*return*/];
        }
    });
}
function handleVerifyLoggedOutAccess(_a) {
    var isLoggedIn;
    var _b = _a.payload, action = _b.action, restrictedActionName = _b.restrictedActionName;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(action)];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(handleRestrictLoggedOut, restrictLoggedOut({ restrictedActionName: restrictedActionName }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default function loggedOutRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(restrictLoggedOut, handleRestrictLoggedOut),
                    takeEvery(VERIFY_ACCESS, handleVerifyLoggedOutAccess),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map